<template>
  <div class="panel panel-default">
    <div class="panel-body">
      <div class="panel-title">
        {{
          lang.get('judging.fast_start.rounds.' + (round.id ? 'edit' : 'new'))
        }}
      </div>
      <validation-errors></validation-errors>
      <round-dates
        :start-date="{ datetime: round.startsAt, timezone: round.startsTz }"
        :end-date="{ datetime: round.endsAt, timezone: round.endsTz }"
        @updated="onUpdated"
      />
      <button class="btn btn-primary" :disabled="validating" @click="onSave">
        {{ lang.get('buttons.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { route } from '@/lib/utils.js';
import buildFormData from '@/lib/formdata';
import RoundDates from '@/lib/components/Rounds/RoundDates';
import ValidationErrors from '@/lib/components/Shared/ValidationErrors';
import validateResourceMixin from '../validate-resource-mixin.js';

export default {
  inject: ['lang'],
  components: {
    RoundDates,
    ValidationErrors
  },
  mixins: [validateResourceMixin],
  props: {
    roundId: {
      type: [String, Number],
      default: null
    },
    roundTemplate: {
      type: Object,
      default: () => ({})
    },
    routes: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      round: null
    };
  },
  computed: {
    ...mapState('judgingFastStart', ['rounds'])
  },
  created() {
    const round = this.roundId
      ? this.rounds.find(r => r.id === this.roundId)
      : this.roundTemplate;

    this.round = JSON.parse(JSON.stringify(round));
  },
  beforeDestroy() {
    this.resetValidationErrors();
  },
  methods: {
    ...mapMutations('global', ['resetValidationErrors']),
    ...mapMutations('judgingFastStart', ['addRound', 'updateRound']),
    validateRound() {
      // Build form data
      const data = buildFormData({
        startDate: this.round.startsAt,
        startTimezone: this.round.startsTz,
        endDate: this.round.endsAt,
        endTimezone: this.round.endsTz
      });

      // Validate round
      return this.validateResource(
        route(this.routes['fast-start.round.validate']),
        data
      );
    },
    onUpdated(property, date) {
      // In case of a judging round we can safely ignore the reviewEnd date
      if (property === 'reviewEnd') {
        return;
      }

      this.$set(this.round, `${property}sAt`, date.datetime);
      this.$set(this.round, `${property}sTz`, date.timezone);
    },
    onSave() {
      this.validateRound().then(isValid => {
        if (isValid) {
          if (this.round.id) {
            // Update round
            this.updateRound({ ...this.round });
          } else {
            // New round from template
            this.addRound({
              ...this.round,
              id: 'new-' + Date.now(),
              name: this.lang.get('judging.fast_start.rounds.new'),
              selected: true
            });
          }
          this.resetValidationErrors();
          this.$emit('saved');
        }
      });
    }
  }
};
</script>
